<script>
  import Navbar from "./Navbar.svelte";
  import CodeCard from "../src/components/codecard.svelte";
  export let name;

  const getStarted = () => {
    window.open("https://docs.wowflow.app", '_blank');
  }
</script>

<Navbar />
<main>
  <div class="container">
    <div>
      <h2>Easy Integrations</h2>
      <p>
        Integrate your order management system directly with our factory’s
        workflow, streamlining the entire production process.
      </p>
      <button on:click={getStarted}>GET STARTED</button>
      <CodeCard />
    </div>
    <div class="section-right">

      <svg
        width="350"
        height="169"
        viewBox="0 0 454 169"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="178" cy="55" r="55" fill="white" />
        <path
          d="M190.733 29.7835C190.571 29.7839 190.411 29.8208 190.265 29.8917C190.119 29.9626 189.991 30.0655 189.891 30.1928C189.79 30.3201 189.72 30.4685 189.684 30.6269C189.649 30.7853 189.65 30.9497 189.687 31.1077L194.912 53.1975H209.726L199.367 30.4131C199.281 30.225 199.142 30.0656 198.968 29.954C198.794 29.8423 198.592 29.7832 198.385 29.7835H190.733Z"
          fill="#3BA9E0"
        />
        <path
          d="M189.688 78.1203C189.65 78.2784 189.649 78.4429 189.684 78.6016C189.719 78.7603 189.789 78.909 189.89 79.0365C189.991 79.1639 190.119 79.2669 190.265 79.3375C190.412 79.4082 190.572 79.4448 190.734 79.4445H198.386C198.592 79.4442 198.794 79.3847 198.967 79.2731C199.141 79.1615 199.278 79.0025 199.364 78.8149L209.727 56.027H194.912L189.688 78.1203Z"
          fill="#3BA9E0"
        />
        <path
          d="M169.07 29.7835C168.908 29.7838 168.748 29.8208 168.602 29.8917C168.456 29.9626 168.328 30.0655 168.228 30.1928C168.127 30.3201 168.057 30.4685 168.021 30.6269C167.986 30.7853 167.987 30.9497 168.024 31.1077L173.245 53.1975H188.06L177.7 30.4131C177.614 30.2255 177.477 30.0665 177.303 29.9549C177.13 29.8433 176.928 29.7838 176.722 29.7835H169.07Z"
          fill="#3BA9E0"
        />
        <path
          d="M168.024 78.1203C167.987 78.2767 167.985 78.4395 168.019 78.5966C168.053 78.7538 168.121 78.9014 168.22 79.0285C168.318 79.1555 168.444 79.2589 168.588 79.3309C168.731 79.4029 168.889 79.4417 169.05 79.4444H176.705C176.911 79.4441 177.113 79.3847 177.286 79.2731C177.46 79.1615 177.597 79.0024 177.683 78.8149L188.043 56.027H173.245L168.024 78.1203Z"
          fill="#3BA9E0"
        />
        <path
          d="M147.403 29.7863C147.241 29.7867 147.081 29.8236 146.935 29.8945C146.789 29.9654 146.661 30.0683 146.561 30.1956C146.46 30.3229 146.39 30.4713 146.354 30.6297C146.319 30.7881 146.32 30.9525 146.357 31.1105L151.581 53.2003H166.396L156.037 30.4159C155.95 30.2283 155.812 30.0694 155.638 29.9579C155.464 29.8463 155.262 29.7868 155.055 29.7863H147.403Z"
          fill="#3BA9E0"
        />
        <path
          d="M146.358 78.1203C146.32 78.2784 146.318 78.4429 146.353 78.6016C146.388 78.7603 146.459 78.909 146.56 79.0365C146.66 79.1639 146.789 79.2669 146.935 79.3375C147.081 79.4082 147.241 79.4448 147.404 79.4445H155.056C155.262 79.4442 155.463 79.3847 155.637 79.2731C155.81 79.1615 155.948 79.0025 156.034 78.8149L166.393 56.027H151.578L146.358 78.1203Z"
          fill="#3BA9E0"
        />
        <path opacity="0.5" d="M233 55H289.5" stroke="white" stroke-width="5" />
        <path
          d="M276 55C276 64.3888 283.611 72 293 72L293 38C283.611 38 276 45.6112 276 55Z"
          fill="white"
        />
        <path
          d="M288 50L302 50"
          stroke="white"
          stroke-width="3"
          stroke-linejoin="round"
        />
        <path
          d="M288 61L302 61"
          stroke="white"
          stroke-width="3"
          stroke-linejoin="round"
        />
        <path opacity="0.5" d="M372 55H315.5" stroke="white" stroke-width="5" />
        <path
          d="M329 55C329 64.3888 321.389 72 312 72L312 38C321.389 38 329 45.6112 329 55Z"
          fill="white"
        />
        <path
          opacity="0.5"
          d="M178 96.0001L178 131.5C178 143.098 168.598 152.5 157 152.5L129.5 152.5"
          stroke="white"
          stroke-width="5"
        />
        <path
          d="M137 152C137 161.389 129.389 169 120 169L120 135C129.389 135 137 142.611 137 152Z"
          fill="white"
        />
        <path
          d="M125 147L111 147"
          stroke="white"
          stroke-width="3"
          stroke-linejoin="round"
        />
        <path
          d="M125 158L111 158"
          stroke="white"
          stroke-width="3"
          stroke-linejoin="round"
        />
        <path
          opacity="0.5"
          d="M41 96L41 131.5C41 143.098 50.402 152.5 62 152.5L89.5 152.5"
          stroke="white"
          stroke-width="5"
        />
        <path
          d="M82 152C82 161.389 89.6112 169 99 169L99 135C89.6112 135 82 142.611 82 152Z"
          fill="white"
        />
        <circle cx="41" cy="56" r="41" fill="white" />
        <path
          d="M22.075 64.24C20.379 64.24 18.843 63.872 17.467 63.136C16.107 62.384 15.035 61.352 14.251 60.04C13.483 58.728 13.099 57.248 13.099 55.6C13.099 53.952 13.491 52.472 14.275 51.16C15.059 49.848 16.131 48.824 17.491 48.088C18.867 47.336 20.403 46.96 22.099 46.96C23.475 46.96 24.731 47.2 25.867 47.68C27.003 48.16 27.963 48.856 28.747 49.768L26.731 51.664C25.515 50.352 24.019 49.696 22.243 49.696C21.091 49.696 20.059 49.952 19.147 50.464C18.235 50.96 17.523 51.656 17.011 52.552C16.499 53.448 16.243 54.464 16.243 55.6C16.243 56.736 16.499 57.752 17.011 58.648C17.523 59.544 18.235 60.248 19.147 60.76C20.059 61.256 21.091 61.504 22.243 61.504C24.019 61.504 25.515 60.84 26.731 59.512L28.747 61.432C27.963 62.344 26.995 63.04 25.843 63.52C24.707 64 23.451 64.24 22.075 64.24ZM42.7285 64L39.2965 59.08C39.1525 59.096 38.9365 59.104 38.6485 59.104H34.8565V64H31.7365V47.2H38.6485C40.1045 47.2 41.3685 47.44 42.4405 47.92C43.5285 48.4 44.3605 49.088 44.9365 49.984C45.5125 50.88 45.8005 51.944 45.8005 53.176C45.8005 54.44 45.4885 55.528 44.8645 56.44C44.2565 57.352 43.3765 58.032 42.2245 58.48L46.0885 64H42.7285ZM42.6565 53.176C42.6565 52.104 42.3045 51.28 41.6005 50.704C40.8965 50.128 39.8645 49.84 38.5045 49.84H34.8565V56.536H38.5045C39.8645 56.536 40.8965 56.248 41.6005 55.672C42.3045 55.08 42.6565 54.248 42.6565 53.176ZM64.7232 64L64.6992 52.864L59.1792 62.08H57.7872L52.2672 53.008V64H49.2912V47.2H51.8592L58.5312 58.336L65.0832 47.2H67.6512L67.6752 64H64.7232Z"
          fill="#0B0938"
        />
        <circle cx="413" cy="55" r="41" fill="white" />
        <path
          d="M407.848 63L407.824 51.864L402.304 61.08H400.912L395.392 52.008V63H392.416V46.2H394.984L401.656 57.336L408.208 46.2H410.776L410.8 63H407.848ZM415.338 46.2H418.458V63H415.338V46.2ZM428.21 63.24C426.914 63.24 425.658 63.056 424.442 62.688C423.242 62.32 422.29 61.832 421.586 61.224L422.666 58.8C423.354 59.344 424.194 59.792 425.186 60.144C426.194 60.48 427.202 60.648 428.21 60.648C429.458 60.648 430.386 60.448 430.994 60.048C431.618 59.648 431.93 59.12 431.93 58.464C431.93 57.984 431.754 57.592 431.402 57.288C431.066 56.968 430.634 56.72 430.106 56.544C429.578 56.368 428.858 56.168 427.946 55.944C426.666 55.64 425.626 55.336 424.826 55.032C424.042 54.728 423.362 54.256 422.786 53.616C422.226 52.96 421.946 52.08 421.946 50.976C421.946 50.048 422.194 49.208 422.69 48.456C423.202 47.688 423.962 47.08 424.97 46.632C425.994 46.184 427.242 45.96 428.714 45.96C429.738 45.96 430.746 46.088 431.738 46.344C432.73 46.6 433.586 46.968 434.306 47.448L433.322 49.872C432.586 49.44 431.818 49.112 431.018 48.888C430.218 48.664 429.442 48.552 428.69 48.552C427.458 48.552 426.538 48.76 425.93 49.176C425.338 49.592 425.042 50.144 425.042 50.832C425.042 51.312 425.21 51.704 425.546 52.008C425.898 52.312 426.338 52.552 426.866 52.728C427.394 52.904 428.114 53.104 429.026 53.328C430.274 53.616 431.298 53.92 432.098 54.24C432.898 54.544 433.578 55.016 434.138 55.656C434.714 56.296 435.002 57.16 435.002 58.248C435.002 59.176 434.746 60.016 434.234 60.768C433.738 61.52 432.978 62.12 431.954 62.568C430.93 63.016 429.682 63.24 428.21 63.24Z"
          fill="#0B0938"
        />
      </svg>
      <h2>Powerful and feature rich APIs</h2>
      <p>
        Our API is designed to enable the most flexible and powerful PSP
        integration available, we have an experienced team to help with every
        step of the integration.
      </p>
    </div>
  </div>
</main>

<style>
  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,300;0,400;0,600;0,700;0,900;1,100&display=swap");

  :global(body) {
    /* IE10 Consumer Preview */
    background-image: -ms-linear-gradient(bottom, #3ba9e0 0%, #0b0937 100%);
    /* Mozilla Firefox */
    background-image: -moz-linear-gradient(bottom, #3ba9e0 0%, #0b0937 100%);
    /* Opera */
    background-image: -o-linear-gradient(bottom, #3ba9e0 0%, #0b0937 100%);
    /* Webkit (Safari/Chrome 10) */
    background-image: -webkit-gradient(
      linear,
      left bottom,
      left top,
      color-stop(0, #3ba9e0),
      color-stop(1, #0b0937)
    );
    /* Webkit (Chrome 11+) */
    background-image: -webkit-linear-gradient(bottom, #3ba9e0 0%, #0b0937 100%);
    /* W3C Markup, IE10 Release Preview */
    background-image: linear-gradient(to top, #3ba9e0 0%, #0b0937 100%);

    color: #ffff;

    font-family: "Montserrat", sans-serif;
  }

  .container {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .container div {
	  flex-basis: 30%;
	  margin: 50px;
  }

	.section-right{
		align-self: flex-end;
	}

  h1 {
    color: #ffff;
    text-transform: uppercase;
    font-size: 4em;
    font-weight: 100;
  }

  h2 {
    font-weight: 600;
  }

  button {
    background: #3ba9e0;
    color: white;
    padding: 1rem 3rem;
    border: none;
    border-radius: 7px;
  	margin: 2rem 0 2rem 0;
    cursor: pointer;
  }
  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }
</style>
